/* eslint-disable max-len */
export default {
  en: {
    project: {
      new: 'New Project',
      create: 'Create Project',
      createDescription:
        'The repository contains all project files and the history of their changes',
      title: 'Project Title',
      titlePlaceholder: 'My new cool project',
      language: 'Programming language',
      url: 'Project URL',
      public: 'Public Project',
      publicDescription:
        'Any internet user can see this repository. You choose who can commit to this repository.',
      noneOauth2:
        'To create public projects you need to authorize with OAuth2 (VK/Yandex) in your | personal cabinet settings.',
      private: 'Private project',
      privateDescription: 'You choose who can see this repository and who can commit to it.',
      cannotCreate:
        'You cannot create projects. To make this functionality available, please send a request to',
      cannotCreateSelfhosted:
        'You cannot create projects. Please contact your administrator to make this functionality available',
      titleInitProjectWith: 'Initialize this project with:',
      titleAddReadme: 'Add README.md file',
      addReadmeDescription: 'This is where you can write a long description for your project',
      titleGitIgnore: 'Add .gitignore',
      gitIgnoreDescription: 'List of files that will be ignored by Git',
      owner: {
        approverSettingsImport: 'Apply the merge request settings set by the owner',
        branchSettingsImport: 'Apply the settings of branches set by the owner',
        tagSettingsImport: 'Apply the tag protection settings set by the owner',
        pipelineLifeTimeSettingsImport: 'Apply pipeline lifetime settings set by the owner',
        allowImportEnvironmentProtection:
          'Apply the environment protection settings set by the owner'
      },
      addConfiguration: 'Add CI/CD Pipeline Configuration',
      addConfigurationDescription: 'A file that defines the rules and stages of pipeline work',
      defaultBranchCreate: 'Set a name for the default branch',
      defaultBranch: 'Default branch'
    },
    mirror: {
      new: 'New Mirror',
      create: 'Create Mirror',
      createDescription:
        'The repository contains all project files and the history of their changes',
      direction: 'Mirror Direction',
      refSpecs: 'Manually Git Refspec addition'
    },
    importBase: {
      new: 'Project Import',
      create: 'Import project',
      createDescription:
        'The repository contains all project files and the history of their changes'
    },
    importProject: {
      new: 'GitLab Import',
      create: 'Import from GitLab',
      createDescription:
        'You can import your repository from GitLab by downloading the repository archive',
      gitLabFile: 'GitLab Project File',
      settings: {
        labels: {
          gitLabToken: 'GitLab token',
          gitLabImportSettings: 'GitLab import settings'
        },
        common: {
          notRequired: 'not necessary',
          gitLabTokenDescription:
            'If you do not have a token, you will not be able to import release files from private repositories'
        },
        form: {
          entities: {
            projectMembers: 'Project members',
            mergeRequests: 'Merge requests',
            issues: 'Issues',
            protectedBranches: 'Protected branches',
            ciCd: 'CI/CD',
            protectedTags: 'Protected tags',
            release: 'Releases',
            labels: 'Labels',
            approvalRules: 'Approval rules',
            pushRules: 'Push rules',
            wiki: 'Wiki'
          },
          subEntities: {
            mergeRequestsLabels: 'Labels',
            mergeRequestsAssigned: 'Assigned users',
            mergeRequestsReviewers: 'Reviewers',
            mergeRequestsApprovers: 'Approvers',
            mergeRequestsIssues: 'Issues',
            issuesNotes: 'Notes',
            issuesLabels: 'Labels',
            ciCdStages: 'Stages',
            ciCdJobs: 'Jobs',
            releaseFiles: 'Release files'
          }
        }
      }
    },
    massImport: {
      page: {
        hostUrl: 'Host URL',
        accessToken: 'Access Token',
        auth: 'Authenticate',
        import: 'Import',
        new: 'Multiple imports from GitLab',
        create: 'Multiple imports from GitLab',
        createDescription:
          'To import multiple repositories from GitLab to GitFlic, you must log in to GitLab',
        errors: {
          errorTitle: 'Import error',
          noProjects: 'No projects available for import found'
        }
      },
      table: {
        gitlabProjectImportStatus: 'Status',
        gitlabProjectName: 'GitLab Project',
        projectOwner: 'Owner',
        projectTitle: 'Project Name',
        projectAlias: 'Alias',
        projectPrivacy: 'Private',
        logs: 'Logs',
        status: {
          queued: 'Queued',
          waiting: 'Waiting for resource',
          failed: 'Error',
          started: 'Running',
          succeeded: 'Success',
          restarted: 'Restarted'
        },
        selectAll: 'Select all',
        selectAllForAllPages: 'Select on all pages'
      },
      tableItem: {
        changePrivacy: 'Make Private'
      }
    },
    fork: {
      new: 'New Fork',
      create: 'Create Fork',
      createDescription:
        'The repository contains all project files and the history of their changes',
      isPrivate: 'It is not possible to make the fork public, as the original project is private.'
    },
    functionUnavailable: 'Contact the service administrator for access.',
    gitLink: 'Link to git repository',
    gitIgnoreEnable: 'Add .gitignore template',
    gitIgnoreNotSelected: 'Not selected',
    ciCdTemplateNotSelected: 'Not selected'
  },
  ru: {
    project: {
      new: 'Новый проект',
      create: 'Создать проект',
      createDescription: 'Репозиторий содержит все файлы проекта и историю их изменений',
      title: 'Название проекта',
      titlePlaceholder: 'Мой новый крутой проект',
      language: 'Язык программирования',
      url: 'URL Проекта',
      public: 'Публичный проект',
      publicDescription:
        'Любой пользователь интернета может увидеть этот репозиторий. Вы сами выбираете кто сможет делать коммиты в этот репозиторий.',
      noneOauth2:
        'Для создания публичных проектов необходимо авторизироваться с помощью OAuth2 (ВК/Яндекс) в | настройках личного кабинета.',
      private: 'Приватный проект',
      privateDescription:
        'Вы сами выбираете кто может увидеть этот репозиторий и кто сможет делать в нем коммиты.',
      titleInitProjectWith: 'Инициализировать этот проект с:',
      titleAddReadme: 'Добавить README.md файл',
      addReadmeDescription: 'Файл, в котором вы можете добавить описание своего проекта',
      titleGitIgnore: 'Добавить .gitignore',
      gitIgnoreDescription: 'Перечень файлов, которые будут игнорироваться Git',
      cannotCreate:
        'Вы не можете создавать проекты. Чтобы данный функционал стал доступен, отправьте запрос на',
      cannotCreateSelfhosted:
        'Вы не можете создавать проекты. Для того, чтобы данный функционал стал доступен, обратитесь к своему администратору',
      owner: {
        approverSettingsImport: 'Применить настройки запросов на слияние установленных владельцем',
        branchSettingsImport: 'Применить настройки веток установленных владельцем',
        tagSettingsImport: 'Применить настройки защиты тегов установленных владельцем',
        pipelineLifeTimeSettingsImport:
          'Применить настройки времени существования конвейеров установленных владельцем',
        allowImportEnvironmentProtection:
          'Применить настройки защиты окружений установленных владельцем'
      },
      addConfiguration: 'Добавить конфигурацию CI/CD конвейеров',
      addConfigurationDescription: 'Файл, в котором определены правила и этапы работы конвейеров',
      defaultBranchCreate: 'Задать имя стандартной ветке',
      defaultBranch: 'Стандартная ветка'
    },
    mirror: {
      new: 'Новое зеркало',
      create: 'Создать зеркало',
      createDescription: 'Репозиторий содержит все файлы проекта и историю их изменений',
      direction: 'Направление зеркала',
      refSpecs: 'Ручное добавление Git Refspec'
    },
    importBase: {
      new: 'Импорт проекта',
      create: 'Импорт проекта',
      createDescription: 'Репозиторий содержит все файлы проекта и историю их изменений'
    },
    importProject: {
      new: 'Импорт с GitLab',
      create: 'Импорт с GitLab',
      createDescription:
        'Вы можете импортировать свой репозиторий из GitLab загрузив архив с репозиторием',
      gitLabFile: 'Файл проекта GitLab',
      settings: {
        labels: {
          gitLabToken: 'GitLab токен',
          gitLabImportSettings: 'Настройки импорта GitLab'
        },
        common: {
          notRequired: 'не обязательно',
          gitLabTokenDescription:
            'При отсутствии токена вы не сможете импортировать файлы релизов приватных репозиториев'
        },
        form: {
          entities: {
            projectMembers: 'Участники проекта',
            mergeRequests: 'Запросы на слияние',
            issues: 'Проблемы',
            protectedBranches: 'Защищенные ветки',
            ciCd: 'CI/CD',
            protectedTags: 'Защищенные теги',
            release: 'Релизы',
            labels: 'Лейблы',
            approvalRules: 'Правила одобрения',
            pushRules: 'Правила push-операций',
            wiki: 'Вики'
          },
          subEntities: {
            mergeRequestsLabels: 'Лейблы',
            mergeRequestsAssigned: 'Назначенные пользователи',
            mergeRequestsReviewers: 'Рецензенты',
            mergeRequestsApprovers: 'Утверждающие',
            mergeRequestsIssues: 'Проблемы',
            issuesNotes: 'Комментарии',
            issuesLabels: 'Лейблы',
            ciCdStages: 'Стадии',
            ciCdJobs: 'Задачи',
            releaseFiles: 'Файлы релизов'
          }
        }
      }
    },
    massImport: {
      page: {
        hostUrl: 'URL-адрес хоста',
        accessToken: 'Токен доступа',
        auth: 'Аутентифицировать',
        import: 'Импортировать',
        new: 'Множественный импорт с GitLab',
        create: 'Множественный импорт с GitLab',
        createDescription:
          'Для множественного импорта репозиториев с GitLab на GitFlic — необходимо авторизоваться в GitLab',
        errors: {
          errorTitle: 'Ошибка импорта',
          noProjects: 'Проектов, доступных для импорта, не найдено'
        }
      },
      table: {
        gitlabProjectImportStatus: 'Статус',
        gitlabProjectName: 'Проект GitLab',
        projectOwner: 'Владелец',
        projectTitle: 'Название проекта',
        projectAlias: 'Алиас',
        projectPrivacy: 'Приватный',
        logs: 'Логи',
        status: {
          queued: 'В очереди',
          waiting: 'Ожидает ресурсы',
          failed: 'Ошибка',
          started: 'Выполняется',
          succeeded: 'Успех',
          restarted: 'Перезапущен'
        },
        selectAll: 'Выбрать все',
        selectAllForAllPages: 'Выбрать на всех страницах'
      },
      tableItem: {
        changePrivacy: 'Сделать приватным'
      }
    },
    fork: {
      new: 'Новый форк',
      create: 'Создать форк',
      createDescription: 'Репозиторий содержит все файлы проекта и историю их изменений',
      isPrivate:
        'Невозможно сделать форк публичным, так как оригинальный проект является приватным.'
    },
    searchCode: {
      showMatch: "Показать еще совпадения ()"
    },
    functionUnavailable: 'Обратитесь к администратору сервиса для получения доступа.',
    gitLink: 'Ссылка на git репозиторий',
    gitIgnoreEnable: 'Добавить .gitignore шаблон',
    gitIgnoreNotSelected: 'Не выбрано',
    ciCdTemplateNotSelected: 'Не выбрано'
  }
};
